// YC — scripts propios de la tienda. Vanilla JS, sin dependencias externas.
// Varias secciones cargan este mismo archivo (una etiqueta <script> cada una);
// esta guarda evita que se inicialice más de una vez en la misma página.
if (!window.__ycScriptsInit) {
  window.__ycScriptsInit = true;
  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initCountUp();
    initComparadores();
    initGaleriaProducto();
    initVariantes();
    initPaquetes();
    initModoOscuro();
  });
}

// ---- Reveal al hacer scroll -----------------------------------------------
function initReveal() {
  var els = document.querySelectorAll('.yc-reveal');
  if (!els.length) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) {
    els.forEach(function (el) { el.classList.add('yc-visible'); });
    return;
  }

  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('yc-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });

  els.forEach(function (el, i) {
    el.style.setProperty('--yc-delay', Math.min(i % 6, 5) * 0.08 + 's');
    obs.observe(el);
  });
}

// ---- Cifras animadas --------------------------------------------------------
function initCountUp() {
  var els = document.querySelectorAll('[data-yc-countup]');
  if (!els.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      obs.unobserve(entry.target);
      var el = entry.target;
      var end = parseFloat(el.getAttribute('data-yc-countup')) || 0;
      var suffix = el.getAttribute('data-yc-suffix') || '';
      if (reduce) { el.textContent = end + suffix; return; }
      var duration = 1600;
      var start = performance.now();
      function tick(now) {
        var p = Math.min((now - start) / duration, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(end * eased) + suffix;
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    });
  }, { threshold: 0.5 });

  els.forEach(function (el) { obs.observe(el); });
}

// ---- Comparador antes/después ----------------------------------------------
function initComparadores() {
  var comps = document.querySelectorAll('.yc-comparador');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  comps.forEach(function (comp) {
    var antes = comp.querySelector('.yc-comparador-antes');
    var asa = comp.querySelector('.yc-comparador-asa');
    if (!antes || !asa) return;
    var dragging = false;
    var demoTimer = null;

    function setPct(pct) {
      pct = Math.min(Math.max(pct, 0), 100);
      antes.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      asa.style.left = pct + '%';
      return pct;
    }
    function setPosFromClientX(clientX) {
      var rect = comp.getBoundingClientRect();
      setPct(((clientX - rect.left) / rect.width) * 100);
    }
    function animarA(pct, duracion) {
      var inicio = performance.now();
      var desde = parseFloat(asa.style.left) || 50;
      if (reduce) { setPct(pct); return; }
      function tick(now) {
        var p = Math.min((now - inicio) / duracion, 1);
        var eased = 0.5 - Math.cos(p * Math.PI) / 2;
        setPct(desde + (pct - desde) * eased);
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }

    comp.addEventListener('pointerdown', function (e) {
      clearTimeout(demoTimer);
      dragging = true;
      comp.setPointerCapture(e.pointerId);
      setPosFromClientX(e.clientX);
    });
    comp.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      setPosFromClientX(e.clientX);
    });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
      comp.addEventListener(ev, function () { dragging = false; });
    });

    // Botón: alterna entre mostrar "antes" y "después" al completo
    var boton = comp.parentElement && comp.parentElement.querySelector('[data-yc-comparador-boton]');
    if (boton) {
      boton.addEventListener('click', function () {
        clearTimeout(demoTimer);
        var mostrandoDespues = boton.getAttribute('data-estado') !== 'antes';
        if (mostrandoDespues) {
          animarA(0, 500);
          boton.textContent = boton.getAttribute('data-texto-antes') || boton.textContent;
          boton.setAttribute('data-estado', 'antes');
        } else {
          animarA(100, 500);
          boton.textContent = boton.getAttribute('data-texto-despues') || boton.textContent;
          boton.setAttribute('data-estado', 'despues');
        }
      });
    }

    // Animación de entrada: pequeña demo de barrido al aparecer en pantalla
    if (!reduce) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          obs.unobserve(comp);
          setPct(28);
          demoTimer = setTimeout(function () { animarA(50, 500); }, 700);
        });
      }, { threshold: 0.5 });
      obs.observe(comp);
    }
  });
}

// ---- Galería de producto (miniaturas) --------------------------------------
function initGaleriaProducto() {
  var galeria = document.querySelector('[data-yc-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-yc-galeria-principal]');
  var minis = galeria.querySelectorAll('[data-yc-galeria-mini]');
  if (!principal || !minis.length) return;

  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var full = mini.getAttribute('data-full');
      var alt = mini.getAttribute('data-alt') || '';
      if (!full) return;
      principal.style.opacity = '0';
      setTimeout(function () {
        principal.src = full;
        principal.alt = alt;
        principal.style.opacity = '1';
      }, 160);
      minis.forEach(function (m) { m.classList.remove('is-active'); });
      mini.classList.add('is-active');
    });
  });
}

// ---- Selector de variantes ---------------------------------------------------
function initVariantes() {
  var forms = document.querySelectorAll('[data-yc-producto-form]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-yc-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var columna = form.closest('[data-yc-columna-compra]') || form;
    var selects = form.querySelectorAll('[data-yc-opcion]');
    var idInput = form.querySelector('input[name="id"]');
    var precioEl = columna.querySelector('[data-yc-precio]');
    var precioComparado = columna.querySelector('[data-yc-precio-comparado]');
    var botonAgregar = form.querySelector('[data-yc-boton-agregar]');
    var textoAgotado = form.getAttribute('data-yc-texto-agotado') || 'Agotado';
    var textoAgregar = form.getAttribute('data-yc-texto-agregar') || 'Añadir al carrito';

    function moneda(cents) {
      return (cents / 100).toLocaleString(document.documentElement.lang || 'es', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
      });
    }

    function actualizar() {
      if (!selects.length) return;
      var seleccion = Array.prototype.map.call(selects, function (s) { return s.value; });
      var variante = variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
      if (!variante) return;
      idInput.value = variante.id;
      if (precioEl) precioEl.textContent = moneda(variante.price);
      if (precioComparado) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioComparado.textContent = moneda(variante.compare_at_price);
          precioComparado.style.display = '';
        } else {
          precioComparado.style.display = 'none';
        }
      }
      if (botonAgregar) {
        botonAgregar.disabled = !variante.available;
        botonAgregar.toggleAttribute('aria-disabled', !variante.available);
        var etiqueta = botonAgregar.querySelector('span') || botonAgregar;
        etiqueta.textContent = variante.available ? textoAgregar : textoAgotado;
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
    actualizar();
  });
}

// ---- Selector de packs (producto de una sola opción, varias variantes) ------
function initPaquetes() {
  var grupos = document.querySelectorAll('.yc-paquetes');
  grupos.forEach(function (grupo) {
    var form = grupo.closest('[data-yc-producto-form]');
    if (!form) return;
    var columna = form.closest('[data-yc-columna-compra]') || form;
    var idInput = form.querySelector('input[name="id"]');
    var precioEl = columna.querySelector('[data-yc-precio]');
    var precioComparado = columna.querySelector('[data-yc-precio-comparado]');
    var botonAgregar = form.querySelector('[data-yc-boton-agregar]');
    var textoAgotado = form.getAttribute('data-yc-texto-agotado') || 'Agotado';
    var textoAgregar = form.getAttribute('data-yc-texto-agregar') || 'Añadir al carrito';
    var radios = grupo.querySelectorAll('[data-yc-paquete-radio]');

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        radios.forEach(function (r) {
          var tarjeta = r.closest('.yc-paquete');
          if (tarjeta) tarjeta.classList.toggle('is-checked', r.checked);
        });
        idInput.value = radio.value;
        if (precioEl) precioEl.textContent = radio.getAttribute('data-precio');
        if (precioComparado) {
          var comp = radio.getAttribute('data-precio-comparado');
          if (comp) {
            precioComparado.textContent = comp;
            precioComparado.style.display = '';
          } else {
            precioComparado.style.display = 'none';
          }
        }
        var disponible = radio.getAttribute('data-disponible') === 'true';
        if (botonAgregar) {
          botonAgregar.disabled = !disponible;
          botonAgregar.toggleAttribute('aria-disabled', !disponible);
          var etiqueta = botonAgregar.querySelector('span') || botonAgregar;
          etiqueta.textContent = disponible ? textoAgregar : textoAgotado;
        }
      });
    });
  });
}

// ---- Modo oscuro (botón inyectado en la cabecera) ---------------------------
function initModoOscuro() {
  var iconos = document.querySelector('.header__icons');
  if (!iconos || document.querySelector('.yc-modo-oscuro-btn')) return;

  var ESQUEMA_CLARO = 'color-scheme-1';
  var ESQUEMA_OSCURO = 'color-scheme-3';
  var elementosConEsquema = document.querySelectorAll('.header-wrapper, .utility-bar');

  function aplicarEsquema(oscuro) {
    elementosConEsquema.forEach(function (el) {
      el.classList.toggle(ESQUEMA_CLARO, !oscuro);
      el.classList.toggle(ESQUEMA_OSCURO, oscuro);
    });
  }

  var boton = document.createElement('button');
  boton.type = 'button';
  boton.className = 'header__icon yc-modo-oscuro-btn';
  boton.innerHTML =
    '<span class="icon yc-icon-sun"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="12" cy="12" r="4.2"/><path d="M12 3v2.2M12 18.8V21M4.2 12H2M22 12h-2.2M5.6 5.6l1.5 1.5M16.9 16.9l1.5 1.5M18.4 5.6l-1.5 1.5M7.1 16.9l-1.5 1.5"/></svg></span>' +
    '<span class="icon yc-icon-moon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M20 14.5A8.5 8.5 0 1 1 9.5 4a7 7 0 0 0 10.5 10.5Z"/></svg></span>';

  function estaOscuro() { return document.documentElement.getAttribute('data-yc-theme') === 'dark'; }

  function actualizarAria() {
    boton.setAttribute('aria-label', estaOscuro() ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro');
  }

  boton.addEventListener('click', function () {
    var oscuro = !estaOscuro();
    document.documentElement.setAttribute('data-yc-theme', oscuro ? 'dark' : 'light');
    aplicarEsquema(oscuro);
    actualizarAria();
    try { localStorage.setItem('yc-theme', oscuro ? 'dark' : 'light'); } catch (e) {}
  });

  iconos.insertBefore(boton, iconos.firstChild);
  aplicarEsquema(estaOscuro());
  actualizarAria();
}
